/**
 * 获取授权路径
 * @param {string} currentPath - 当前访问的路径（可选）
 * @returns {string} 授权路径
 */
export function getAuthPath(currentPath = '') {
  // 支付宝环境不需要授权
  if (/alipay/i.test(navigator.userAgent)) {
    return null
  }

  // 微信环境
  if (/micromessenger/i.test(navigator.userAgent)) {
    let authPath = '/wxAuthBase'
    let scope = window.localStorage.getItem("scope")

    // 进入个人中心需获取个人信息
    if (currentPath === '/wxAuth' || currentPath === '/mine/index') {
      authPath = '/wxAuth'
      if (!scope || scope === 'snsapi_base') {
        localStorage.setItem('openId', '')
        localStorage.setItem('carparkXtoken', '')
      }
    }

    // 开发环境强制使用 devAuth（根据实际需求调整）
    // authPath = '/devAuth' // todo dev

    return authPath
  }

  return null
}



// WEBPACK FOOTER //
// ./src/utils/auth.js